import type { AnswerMap, CalcConfig } from '../types';

/**
 * Safe, typed aggregator for CalculatedField — sum/average/count over named
 * field handles. Deliberately not a general formula-string evaluator: this
 * covers PHQ-9/GAD-7-style total scoring without an eval()-style injection
 * surface. A richer expression engine is a documented future extension.
 */
export function evaluateCalc(calc: CalcConfig, answers: AnswerMap): number {
  const values = calc.sourceHandles
    .map((handle) => answers[handle])
    .filter((v): v is number => typeof v === 'number');

  switch (calc.aggregation) {
    case 'sum':
      return values.reduce((acc, v) => acc + v, 0);
    case 'average':
      return values.length === 0 ? 0 : values.reduce((acc, v) => acc + v, 0) / values.length;
    case 'count':
      return values.length;
    default:
      return 0;
  }
}
